export const enum STEPS_PATH {
    ACADEMIC = 'academic-record',
    MEMBERSHIP = 'membership-register',
    COMPLETED = 'completed'
}
